import { PropsWithChildren } from "react";

/**
 * Text for the link name.
 */
export const LinkNameSpan: React.FC<PropsWithChildren> = ({ children }) => (
  <span className="shrink overflow-hidden text-ellipsis whitespace-nowrap">
    {children}
  </span>
);

/**
 * Should contain the icon and any additional details for the link.
 * This will not be ellipsis-clipped.
 */
export const LinkDetailsSpan: React.FC<PropsWithChildren> = ({ children }) => (
  <span className="shrink-0">{children}</span>
);
